import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "td__container" }
const _hoisted_2 = {
  key: 0,
  class: "td__date"
}
const _hoisted_3 = { class: "td__date_date" }
const _hoisted_4 = {
  key: 1,
  class: "td__time"
}
const _hoisted_5 = { class: "td__time_time" }
const _hoisted_6 = {
  key: 2,
  class: "td__timezone"
}
const _hoisted_7 = { class: "td__timezone_tz" }
const _hoisted_8 = {
  key: 3,
  class: "td__time"
}
const _hoisted_9 = { class: "td__time_time" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeDisplay',
  props: {
  date: { type: Date, required: true },
  ampm: { type: Boolean, default: false },
  showDate: { type: Boolean, default: true, required: false },
  showTimezone: { type: Boolean, default: true, required: false },
  shortTimeDate: { type: Boolean, default: false, required: false },
  timezone: { 
    type: String, 
    default: Intl.DateTimeFormat().resolvedOptions().timeZone, 
    required: false 
  }
},
  setup(__props) {

const props = __props;

function pad(number: number, length: number = 2): string {
  return String(number).padStart(length, '0');
}


const hours = computed(() => {
  if (props.ampm) {
    const hour = props.date.getHours() % 12;
    return hour === 0 ? 12 : hour;
  } else {
    return props.date.getHours();
  }
});


const ampm = computed(() => {
  return props.date.getHours() >= 12 ? 'PM' : 'AM';
});

const shortTimeDateString = computed(() => {
  // return date formatted as Oct 3 9:00 AM
  const month = props.date.toLocaleString('default', { month: 'short' });
  const day = props.date.getDate();
  const hour = props.date.getHours() % 12;
  const minute = pad(props.date.getMinutes());
  const ampm = props.date.getHours() >= 12 ? 'PM' : 'AM';
  const tz =  props.timezone;
  return `${month} ${day} ${hour}:${minute} ${ampm}` + (props.showTimezone ? ` ${tz}` : '');
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showDate && !props.shortTimeDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.date.toLocaleString('default', { month: 'long' })) + " " + _toDisplayString(pad(props.date.getDate())) + ", " + _toDisplayString(props.date.getFullYear()), 1)
        ]))
      : _createCommentVNode("", true),
    (!props.shortTimeDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(pad(hours.value)) + ":" + _toDisplayString(pad(props.date.getMinutes())) + ":" + _toDisplayString(pad(props.date.getSeconds())) + " " + _toDisplayString(props.ampm ? ampm.value : ''), 1)
        ]))
      : _createCommentVNode("", true),
    (props.showTimezone && !props.shortTimeDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(props.timezone), 1)
        ]))
      : _createCommentVNode("", true),
    (props.shortTimeDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(shortTimeDateString.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})